import _axios from '../../apiClient'

export function GetOfertasActivas() {
  return _axios
    .get(`/api/Oferta/GetOfertasActivas`, {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    })
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function getOfertas() {
  return _axios
    .get(`/api/Oferta/GetOfertas`, {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    })
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}
/*
export function getOfertaById(payload) {
  return _axios.get(`/api/Oferta/GetOfertaById?id=${payload}`)

    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}
*/

export function putOferta(payload) {
  let formData = new FormData()
  if (payload.file) {
    let editFile = payload.file
    formData.append('file', editFile)
  }
  if (payload.tag) {
    let tag = payload.tag
    formData.append('tag', tag)
  }

  return _axios
    .put(
      '/api/Oferta/EditarOferta?idOferta=' +
        payload.idOferta +
        '&nombre=' +
        payload.nombre +
        (payload.fechaDesde !== undefined
          ? '&fechaDesde=' + payload.fechaDesde
          : '') +
        (payload.fechaHasta !== undefined
          ? '&fechaHasta=' + payload.fechaHasta
          : ''),
      formData,
      {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function borrarOferta(payload) {
  return _axios
    .get(`/api/Oferta/BorrarOferta`, {
      params: {
        idOferta: payload,
      },
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    })
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function saveOferta(payload) {
  let newFile = payload.file
  let formData = new FormData()
  formData.append('file', newFile)
  if (payload.tag) {
    let tag = payload.tag
    formData.append('tag', tag)
  }

  return _axios
    .post(
      `/api/Oferta/SaveOferta?nombre=${payload.nombre}${
        payload.desde ? `&fechaDesde=${payload.desde}` : ''
      }${payload.hasta ? `&fechaHasta=${payload.hasta}` : ''}`, //&textoLargo=${payload.textoLargo}
      formData,
      {
        headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}

export function swapOferta(payload) {
  return _axios
    .get(`/api/Oferta/SwapOferta`, {
      params: {
        ids: payload.ids.join('-'),
      },
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    })
    .then((response) => response.data)
    .catch((error) => {
      const data = error.response.data
      throw data
    })
}
